export default __webpack_public_path__ + "static/media/mark-testi.f098868a.jpg";